import { selectTranslations } from 'app/pages/App/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'utils/hooks/useSearchParams';
import { Layout } from '../layouts';
import { ACCOUNT_MNG_MENU } from '../layouts/AccountManager';
import PaymentDetail from './PaymentDetail';
import PaymentInput from './PaymentInput';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

export default function AutoDeposit() {
  const translations = useSelector(selectTranslations);
  const { getUrlParam } = useSearchParams();
  const history = useHistory();
  const renderView = () => {
    if (getUrlParam('id')) {
      return <PaymentDetail />;
    }
    return <PaymentInput />;
  };

  return (
    <Layout
      title={
        !getUrlParam('id') && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: '100%',
            }}
          >
            <TextLink
              onClick={() =>
                history.push('/topup-history', {
                  from: '/auto-deposit',
                })
              }
            >
              {translations?.['b2b.txt.topUpHistory'] ?? ''}
            </TextLink>
            <Title style={{ marginTop: 10, marginBottom: 10 }}>
              {translations?.['b2b.autoDeposit']}
            </Title>
          </div>
        )
      }
      menuActive={ACCOUNT_MNG_MENU.AUTO_DEPOSIT}
    >
      <div style={{ height: 20 }} />

      {renderView()}
    </Layout>
  );
}

const Title = styled.h3`
  color: #f06f24;
  font-weight: bold;
  font-size: 36px;
`;

const TextLink = styled.p`
  align-self: flex-end;
  margin: 0;
  color: #e92127;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  &:hover {
    text-decoration: underline;
  }
`;
